export default "__VITE_ASSET__BHnNPF2G__"